module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: 'siderbar' + _vm.modusOption.key,
    staticClass: "ksm-sidebar__wrapper"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container",
    style: (_vm.sidebarPageStyle)
  }, [_vm._l((_vm.accordionList), function(it, i) {
    return [_c('div', {
      key: 't' + i,
      staticClass: "ksm-accordion__header",
      style: (i == 0 ? 'border-top-color:transparent' : '')
    }, [(_vm.modusOption.key !== 'ansicht' && _vm.modusOption.key !== 'komposition') ? _c('div', {
      staticStyle: {
        "width": "22px",
        "height": "100%",
        "padding": "3px"
      },
      domProps: {
        "innerHTML": _vm._s(!_vm.showArrow ? '' : _vm.$_getIcon(_vm.openedAccordionId === it.id ? 'arrow-down.svg' : 'arrow-right.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(it.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ksm-flex-1 ksm-flex",
      staticStyle: {
        "align-items": "center"
      },
      style: ((_vm.modusOption.key === 'ansicht' || _vm.modusOption.key === 'komposition') ? 'margin-left:10px' : ''),
      on: {
        "click": function($event) {
          return _vm.selectItem(it.id)
        }
      }
    }, [_vm._v(_vm._s(it.label))]), _vm._v(" "), (it.transcriptButtonEnable || it.kategorieButtonEnable) ? _c('div', {
      staticClass: "ksm-accordion__header-tool",
      class: it.id
    }, [(it.transcriptButtonEnable) ? _c('div', {
      staticClass: "ksm-accordion__svg-btn",
      class: it.transcriptButtonChecked ? '__aktiv' : 'inaktiv',
      staticStyle: {
        "width": "40px"
      },
      domProps: {
        "innerHTML": _vm._s(it.transcriptButtonChecked ? _vm.$_getSvg('transkriptionen-aktiv.svg') : _vm.$_getSvg('transkriptionen-inaktiv.svg'))
      },
      on: {
        "click": function($event) {
          it.transcriptButtonChecked = !it.transcriptButtonChecked
        }
      }
    }) : _vm._e(), _vm._v(" "), (it.kategorieButtonEnable) ? _c('div', {
      staticClass: "ksm-accordion__svg-btn",
      class: it.kategorieButtonChecked ? '__aktiv' : 'inaktiv',
      staticStyle: {
        "width": "20px"
      },
      domProps: {
        "innerHTML": _vm._s(it.kategorieButtonChecked ? _vm.$_getSvg('relationen-aktiv.svg') : _vm.$_getSvg('relationen-inaktiv.svg'))
      },
      on: {
        "click": function($event) {
          it.kategorieButtonChecked = !it.kategorieButtonChecked
        }
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      key: 'b' + i,
      staticClass: "ksm-accordion__body",
      class: _vm.openedAccordionId === it.id ? ('ksm-accordion__expand ' + _vm.modusOption.key + 'smodus') : 'ksm-accordion__collapse ' + _vm.modusOption.key + 'smodus',
      on: {
        "click": _vm.handleMouseclick,
        "mouseover": _vm.handleMouseover,
        "mouseout": _vm.handleMouseout
      }
    }, [_c('div', {
      staticClass: "ksm-accordion__content"
    }, [(it.id == 'acco_kommentar') ? _c('div', {
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, _vm._l((_vm.mainKommentar), function(mk, mki) {
      return _c('div', {
        key: mki,
        staticClass: "ksm-accordion__section",
        domProps: {
          "innerHTML": _vm._s(mk)
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (['acco_uebersetzung', 'acco_relation'].indexOf(it.id) > -1 && _vm.noteHtmlData) ? _c('div', {
      staticStyle: {
        "padding": "10px 0px"
      }
    }, _vm._l((_vm.noteHtmlData[it.id]), function(n, j) {
      return _c('div', {
        key: j,
        domProps: {
          "innerHTML": _vm._s(n)
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (it.id === 'acco_einzelstellenkommentare' && _vm.noteHtmlData) ? _c('div', _vm._l((_vm.noteHtmlData[it.id]), function(n, j) {
      return _c('div', {
        key: j,
        domProps: {
          "innerHTML": _vm._s(n)
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (it.id === 'acco_elementebibliothek') ? _c('div', {
      staticClass: "ksm-flex",
      staticStyle: {
        "flex-wrap": "wrap"
      }
    }, _vm._l((_vm.cropImageList), function(obj, oi) {
      return _c('div', {
        key: 'o' + oi,
        staticClass: "ksm-flex-xy-center",
        staticStyle: {
          "padding": "5px",
          "width": "100px",
          "height": "100px",
          "border": "1px solid #fff",
          "margin": "5px"
        },
        attrs: {
          "data-acco": it.id + '#' + obj.id,
          "data-transcript": [obj.id]
        }
      }, [_c('img', {
        staticStyle: {
          "max-width": "100%",
          "max-height": "100%"
        },
        attrs: {
          "data-trid": obj.id,
          "draggable": "true",
          "src": obj.src
        },
        on: {
          "dragstart": _vm.imgDragStart,
          "dragend": _vm.imgDragEnd
        }
      })])
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_personen') ? _c('div', _vm._l((_vm.personen), function(p, pi) {
      return _c('div', {
        key: pi,
        staticStyle: {
          "margin": "5px 10px"
        }
      }, [_c('div', {
        staticClass: "ksm-flex-y-center",
        attrs: {
          "data-pid": p.lemmaID
        }
      }, [_c('div', {
        staticClass: "div-with-transcript",
        attrs: {
          "data-acco": it.id + '#' + p.lemmaID,
          "data-transcript": p.transcripts.join(',')
        }
      }, [_vm._v(_vm._s(p.content))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin": "0 0.2em"
        }
      }, [_vm._v("(" + _vm._s(p.docIds.length) + ")")]), _vm._v(" "), _c('div', {
        staticClass: "ksm-user-circle",
        domProps: {
          "innerHTML": _vm._s(_vm.$_getSvg('id-card.svg'))
        },
        on: {
          "click": function($event) {
            return _vm.gotoPerson(p)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ksm-user-arrow",
        domProps: {
          "innerHTML": _vm._s(_vm.$_getIcon(_vm.isAccoPersonExpand(p.lemmaID) ? 'arrow-down.svg' : 'arrow-right.svg'))
        },
        on: {
          "click": function($event) {
            return _vm.togglePersonItem(p.lemmaID)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "ksm-accordion__body",
        class: _vm.isAccoPersonExpand(p.lemmaID) ? '' : 'ksm-accordion__collapse',
        staticStyle: {
          "border-width": "0",
          "padding": "0 10px"
        }
      }, [_c('g-person-merz', {
        staticStyle: {
          "font-size": "10pt",
          "padding-left": "15px"
        },
        attrs: {
          "modusOption": _vm.modusOption,
          "person": p
        }
      })], 1)])
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_inventarisierung') ? _c('div', _vm._l((_vm.acco_inventarisierung), function(inv, j) {
      return _c('div', {
        key: j,
        staticStyle: {
          "padding": "5px"
        },
        style: (j > 0 ? 'border-top:1px solid #fff' : '')
      }, _vm._l((inv.data), function(inv_d, j_d) {
        return _c('div', {
          key: j_d,
          staticStyle: {
            "margin": "5px 0"
          }
        }, [_c('span', {
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(inv_d.label))]), _vm._v(": " + _vm._s(inv_d.value))])
      }), 0)
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_transkription') ? _c('div', [_c('div', {
      staticStyle: {
        "padding": "5px"
      }
    }, _vm._l((_vm.seite.$_docInfo), function(n, j) {
      return _c('div', {
        key: j,
        domProps: {
          "innerHTML": _vm._s(n._source['98_html'])
        }
      })
    }), 0)]) : _vm._e(), _vm._v(" "), (it.id == 'acco_orte') ? _c('div', {
      staticClass: "ksm-texte__modus-main"
    }, [_vm._l((_vm.orte), function(ort, oi) {
      return _c('div', {
        key: oi,
        staticClass: "div-with-transcript ksm-flex-y-center",
        staticStyle: {
          "margin": "5px 10px"
        },
        attrs: {
          "data-acco": it.id + '#' + ort.ID,
          "data-transcript": ort.transcripts.join(',')
        }
      }, [_vm._v(_vm._s(ort.content))])
    }), _vm._v(" "), (_vm.openedAccordionId === 'acco_orte') ? [(_vm.ortGeoData) ? _c('MapView', {
      attrs: {
        "geoData": _vm.ortGeoData,
        "option": {
          hideTimeline: true,
          zoom: 3
        }
      },
      on: {
        "inited": _vm.mapInited
      }
    }) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (it.id == 'acco_themen') ? _c('div', _vm._l((_vm.themen), function(th, j) {
      return _c('div', {
        key: j,
        staticStyle: {
          "padding": "5px"
        }
      }, [_c('div', {
        staticClass: "div-with-transcript ksm-flex-y-center",
        class: th.class + '-hover',
        attrs: {
          "data-acco": it.id + '#' + th.info.ID,
          "data-transcript": th.transcripts.join(',')
        },
        on: {
          "click": function($event) {
            th.checked = !th.checked
          }
        }
      }, [_c('div', {
        class: th.checked ? th.class : '',
        staticStyle: {
          "width": "15px",
          "height": "15px",
          "margin-right": "5px",
          "border": "1px solid #000"
        }
      }), _vm._v("\n                " + _vm._s(th.info.content) + "\n              ")])])
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_seitenvorschau') ? [_c('Thumbnail', {
      attrs: {
        "seiten": _vm.seiten,
        "seiteIdx": _vm.seiteIdx,
        "aligen": 'vertical'
      },
      on: {
        "selectItem": _vm.selectThumbnail
      }
    })] : _vm._e(), _vm._v(" "), (it.id != 'acco_orte') ? _c('div', {
      staticStyle: {
        "height": "100px"
      }
    }) : _vm._e()], 2)])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c149370","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modus/Sidebar.vue
// module id = 1984
// module chunks = 1